<template>
  <show-status
    :value="value"
    :config="{
      0: { label: 'Aguardando', color: '#FF9800' },
      1: { label: 'Executado', color: '#4CAF50' },
      2: { label: 'Cancelado', color: '#F44336' },
      3: { label: 'Enviado', color: '#2196F3' },
      4: { label: 'Não Enviado', color: '#949494' },
      5: { label: 'Expirado', color: '#545454' },
    }"
  />
</template>

<script>
import ShowStatus from '@/components/ShowStatus.vue'

export default {
  name: 'ShowAcaoStatus',
  components: { ShowStatus },
  props: {
    value: null,
  },
}
</script>
